import {Injectable} from '@angular/core';
import { Router} from '@angular/router';
import {LocationStrategy} from '@angular/common';

@Injectable()
export class UserData {
  data:any;

  csrf : any;

  biproDataLoaded : boolean = false;
  isBiproDataLoaded():boolean{
    return this.biproDataLoaded;
  }

  setBiproDataLoaded(value:any){
    this.biproDataLoaded = value;
  }


  getCsrf():string{
    return this.csrf;
  }

  setCsrf(cs : any){
    this.csrf = cs;
  }

  constructor(private router:Router,
              private url:LocationStrategy) {
  }

  setData(data:any) {
    this.data = data;
    console.log("Current user data: " + JSON.stringify(this.data));
  }

  // Loadbar zeigt leider nur ungefähre Zeit, wie lange eine Bipro Anfrage dauern kann, dadurch entsteht auch bei verschiedenen Stages
  //eine andere Ladezeit, Stage T und SI im vergleich zu localhost arbeiten ungefähr 2 mal schneller und bearbeiten anhand vorhandene CPU 10 trheads gleichzeitig.
  // Auf Prod muss es 3 mal schneller sein, da da mehr CPU vorhanden ist.
  // Die ungefähre zeit wurde folgend berechnet: Anzahl Zeilen * 1000 / 1.7vorgangdauer / 100
  //1.9 vorgangsdauer ist ungefähr 1 milisecunde
  getStageMultiplicator():any{
    return (this.url.path().toString().indexOf("maklert.allianz")>-1||this.url.path().toString().indexOf("maklersi.allianz")>-1)?4:
      this.url.path().toString().indexOf("makler.allianz")>-1?6:1;
  }

  isStageP() : boolean{
    return this.url.path().toString().indexOf("makler.allianz") > -1 ? true : false;
  }

  isKraft():any{
     if(this.url.path().toString().indexOf("kraft")>-1){
       return "kraft";
     }
     else if(this.url.path().toString().indexOf("meinkonto")>-1){
       return "meinkonto";
     }
     else if(this.url.path().toString().indexOf("portal")>-1){
       return "portal";
     }
     else{
       return "sach";
     }
  }

  getBensl():string{
    let bensl = null;
    if (this.data) {
      bensl = this.data.bensl;
    }

    if (!bensl) {
      const params = this.router.parseUrl(this.url.path()).queryParams;
      bensl = params['bensl'];
      this.setData(
        {
          bensl: bensl,
          vorname: params['vorname'],
          nachname: params['nachname'],
          email: params['email'],
          benart: params['benart'],
          csrf: params['csrf']
        });

    }

    return bensl;
  }
}
